module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-body"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.publicProfile.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.profileUrl.length > 0 && !_vm.loading) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.publicProfile.profileUrl')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.profileUrl))])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "save": _vm.save,
      "translation": "form.publicProfile",
      "hasLabel": true,
      "labelWidth": "120px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('static.publicProfile.businessHoursTitle')))]), _vm._v(" "), _c('v-open-hours'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('static.publicProfile.businessHourExceptionsTitle')))]), _vm._v(" "), _c('v-exceptional-hours')], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f08be76","hasScoped":false}!./src/app/pages/withNavigation/profile/publicProfile/publicProfile.html
// module id = 2934
// module chunks = 1